import { stringify as yamlStringify } from 'yaml';
import { CANONICAL_FEATURE_KEYS, CANONICAL_FILE_ENTRY_KEYS, CANONICAL_FLOW_KEYS, CANONICAL_IDENTITY_KEYS, CANONICAL_TOP_LEVEL_KEYS, } from './types.js';
function reorder(obj, canonical) {
    const out = {};
    for (const key of canonical) {
        if (key in obj)
            out[key] = obj[key];
    }
    for (const key of Object.keys(obj)) {
        if (!canonical.includes(key))
            out[key] = obj[key];
    }
    return out;
}
function canonFileEntry(entry) {
    if (entry === null || typeof entry !== 'object' || Array.isArray(entry))
        return entry;
    return reorder(entry, CANONICAL_FILE_ENTRY_KEYS);
}
function canonFiles(files) {
    if (files === null || typeof files !== 'object' || Array.isArray(files))
        return files;
    const out = {};
    for (const [role, entry] of Object.entries(files)) {
        out[role] = canonFileEntry(entry);
    }
    return out;
}
function canonFeature(feature) {
    if (feature === null || typeof feature !== 'object' || Array.isArray(feature))
        return feature;
    return reorder(feature, CANONICAL_FEATURE_KEYS);
}
function canonFlow(flow) {
    if (flow === null || typeof flow !== 'object' || Array.isArray(flow))
        return flow;
    return reorder(flow, CANONICAL_FLOW_KEYS);
}
export function canonicalise(doc) {
    const top = reorder(doc, CANONICAL_TOP_LEVEL_KEYS);
    if (top.remedy && typeof top.remedy === 'object' && !Array.isArray(top.remedy)) {
        top.remedy = reorder(top.remedy, CANONICAL_IDENTITY_KEYS);
    }
    if (top.files !== undefined)
        top.files = canonFiles(top.files);
    if (Array.isArray(top.features))
        top.features = top.features.map(canonFeature);
    if (Array.isArray(top.flows))
        top.flows = top.flows.map(canonFlow);
    return top;
}
export function formatRemedy(doc) {
    const canonical = canonicalise(doc);
    const out = yamlStringify(canonical, {
        indent: 2,
        lineWidth: 80,
        minContentWidth: 20,
        doubleQuotedAsJSON: false,
        singleQuote: false,
        defaultStringType: 'PLAIN',
        defaultKeyType: 'PLAIN',
    });
    // yaml.stringify always ends with a single newline; normalise to exactly one.
    return out.endsWith('\n') ? out : out + '\n';
}
//# sourceMappingURL=format.js.map